import { mapState, mapGetters } from "vuex";

export default () => {
  return {
    computed: {
      ...mapState("account", {
        shopInfo: "shopInfo"
      }),
      ...mapState("downgrade", {
        pagesPublishCount: state => state.pagesPublishCount
      }),
      ...mapGetters("downgrade", {
        isNeedToUnpublishProductPage: "isNeedToUnpublishProductPage",
        isNeedToUnpublishArticlePage: "isNeedToUnpublishArticlePage"
      }),
      isNeedToUnpublishProduct() {
        const isGemPagesV7 = this.shopInfo.isGemPagesV7;
        const publishedCount = isGemPagesV7 ? this.pagesPublishCount.publishedProductPagesCount : this.shopInfo.publishedProductPagesCount;

        return this.isNeedToUnpublishProductPage(publishedCount);
      },
      isNeedToUnpublishArticle() {
        const isGemPagesV7 = this.shopInfo.isGemPagesV7;
        const publishedCount = isGemPagesV7 ? this.pagesPublishCount.publishedArticlePagesCount : this.shopInfo.publishedArticlePagesCount;
        return this.isNeedToUnpublishArticlePage(publishedCount);
      }
    }
  };
};
